import createEnum from 'lib/createEnum';

export const SUB_TYPES = createEnum('CREDIT_CARD_REQUEST', 'FILE', 'IMAGE', 'SESSION_END', 'TEXT', 'URL');

// TODO sync this up with the backend statuses
export const SECURE_DATA_STATUSES = createEnum('COMPLETE', 'ERROR', 'SENT', 'TIMEOUT', 'WAITING');

export default {
  SECURE_DATA_STATUSES,
  SUB_TYPES,
};
